import React from 'react';
import Head from 'next/head';
import { Link } from '@components/atoms/Link/Link';
import { Meta } from '@components/atoms/MetaTags/Meta';
import { Title } from '@components/atoms/Title';
import { GetAllRedirectsDocument } from '@src/lib/graphql/generated';
import { createUrqlClient } from '@lib/graphql/urql';

export function RedirectSitemapDetail({ data, entry }) {
  const pages = data.pages ?? [];

  return (
    <div>
      <Head>
        {Meta(
          {
            no_follow: false,
            no_index: true,
          },
          'Weiterleitung Seite ' + data?.page,
        )}
      </Head>
      <Title classProps={{ heading: 'text-xl lg:text-xl mb-6' }} level={1}>
        {entry?.title ?? 'Sitemap - Weiterleitung Seite ' + data?.page}
      </Title>
      <div className="grid gap-2">
        {pages.map((page) => (
          <Link key={page.id} href={page?.redirect_from}>
            {'Weiterleitung für ' + page.redirect_from}
          </Link>
        ))}
      </div>
    </div>
  );
}

export async function sitemapDetailsSsrLogic({ slug }) {
  const { ssrQuery, ssrCache } = createUrqlClient();

  const page = slug ? parseInt(slug.replace('page-', '')) : 1;

  const { data: redirectsData } = await ssrQuery({
    query: GetAllRedirectsDocument,
    variables: {
      portal: 'tvmedia',
      page: page,
    },
  });

  const pages = redirectsData?.redirects?.data.filter((page) => page.redirect_target !== '');

  if (!pages || pages?.length < 1) return { notFound: true };

  const data = {
    pages: pages,
    page: page,
  };

  return {
    props: {
      data,
      urqlState: ssrCache.extractData(),
    },
  };
}
